import fetch from '../../utils/fetch'
import { getSecretFields, clearSecretFields } from '../../utils/datasource-secrets-utils'

async function fetchSecureConfig(dsKey: string) {
    try {
        const res = await fetch(`/admin/creds/${dsKey}:config`, {
            headers: { 'Content-Type': 'application/json' }
        })
        const result = await res.json()
        return (result && result.config) || {}
    } catch (e) {
        console.error(e)
        return {}
    }
}

async function _executeSecretsRequest(endpoint: string, methodType: string, data: any) {
    return fetch(endpoint, {
        method: methodType,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: data && JSON.stringify(data)
    })
}

async function saveSecretData(data: any) {
    return await _executeSecretsRequest('/admin/creds/save', 'POST', data);
}

async function cloneSecretData(data: any) {
    return await _executeSecretsRequest('/admin/creds/clone', 'POST', data);
}

async function deleteSecrets(node: any) {
    const secretFields = getSecretFields(node.mapping.children);
    if (secretFields.length) {
        try {
            await Promise.all(secretFields.map(secret => _deleteSecret(node.id + ':' + secret.key)));
        }
        catch (error) {
            console.log('failed to delete datasource secrets', error);
        }
    }
}

async function _deleteSecret(id: string) {
    return fetch(`/admin/creds/${id}`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors'
    }).then(async res => {
        if (!res.ok) {
            const er = await res.json()
            throw er.message
        }
        return res.json()
    })
}

const secretsActions = self => ({
    fetchSecureConfig,
    getSecretFields,
    clearSecretFields,
    saveSecretData,
    cloneSecretData,
    deleteSecrets: async () => await deleteSecrets(self)
})

export default secretsActions;
